import en from '@/i18n/en';
import ar from '@/i18n/ar';

export default {
  en,
  ar,
};
